import { Link } from 'react-router-dom'
import { EditableSection } from './EditableSection'

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company info - editable */}
          <div>
            <h3 className="text-lg font-semibold mb-4">
              <EditableSection
                sectionKey="footer"
                field="company_name"
                fallback="CloudCMS"
              />
            </h3>
            <div className="text-gray-400 text-sm space-y-2">
              <EditableSection
                sectionKey="footer"
                field="address"
                fallback="123 Rue Example, 75001 Paris"
                isHtml
              />
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="text-gray-400 text-sm space-y-2">
              <p>
                <EditableSection
                  sectionKey="footer"
                  field="phone"
                  fallback="01 23 45 67 89"
                />
              </p>
              <p>
                <EditableSection
                  sectionKey="footer"
                  field="email"
                  fallback="contact@example.com"
                />
              </p>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liens utiles</h3>
            <ul className="text-gray-400 text-sm space-y-2">
              <li>
                <Link to="/mentions-legales" className="hover:text-white transition-colors">
                  Mentions legales
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="hover:text-white transition-colors">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite" className="hover:text-white transition-colors">
                  Politique de confidentialite
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center text-gray-400 text-sm">
          <p>
            © {new Date().getFullYear()}{' '}
            <EditableSection
              sectionKey="footer"
              field="company_name"
              fallback="CloudCMS"
            />
            . Tous droits reserves.
          </p>
        </div>
      </div>
    </footer>
  )
}
